import { stringToNumber } from 'util/stringToNumber';
import { Caption2, IconButton, Typography } from '@web-chat-core/ui-kit';
import { Textarea } from '@web-chat-core/ui-kit/core/TextField/view';
import styled from 'styled-components';

export const MessageForm = styled.form`
    padding: 8px 0px;
    box-sizing: border-box;
    background-color: ${(props) => props.theme.root.colors.basicColors['6%']};
    display: flex;
    border-radius: 8px;
    min-height: 52px;
    position: relative;
    overflow: hidden;
    width: 100%;
    align-content: center;
    flex-wrap: wrap;
`;

export const SendButton = styled(IconButton)`
    bottom: 10px;
    right: 9px;
    position: absolute;
    &:focus:before,
    &:hover:before {
        background-color: unset;
    }
`;

export const MessageTextarea = styled(Textarea)`
    background: none;
    border: none;
    color: ${(props) => props.theme.root.colors.basicColors['90%']};
    outline: none;
    height: 1rem;
    padding: 0px 38px 0px 12px;
    width: 100%;
    overflow: hidden;
`;

export const MessageWrapper = styled.div<{ own: boolean; withMargin: boolean }>`
    background: ${(props) =>
        props.own ? props.theme.message.baseMine.backgroundColor : props.theme.root.colors.basicColors['8%']};
    padding: 10px 12px;
    margin-left: ${(props) => (props.withMargin ? '34px' : '0')};
    border-radius: 16px;
    box-sizing: border-box;
`;
export const MessageWithAvatarWrapper = styled.div<{ own: boolean; last: boolean }>`
    display: flex;
    align-items: end;
    max-width: 100%;
    width: fit-content;
    align-self: ${(props) => (props.own ? 'flex-end' : 'flex-start')};
    margin-bottom: ${(props) => (props.last ? '16px' : '8px')};
`;

export const MessageText = styled.span`
    white-space: pre-wrap;
    font-size: 15px;
    word-break: break-word;
    width: 100%;
    font-style: normal;
    font-weight: normal;
    margin: 0;
    padding: 0;
    color: ${(props) => props.theme.root.colors.basicColors['90%']};
    line-height: 19px;
    a {
        color: ${(props) => props.theme.root.colors.accent.themeAccent};
    }
`;

export const MessageTime = styled.span`
    align-self: center;
    line-height: 18px;
    letter-spacing: -0.5px;
    flex-shrink: 0;
    ${Caption2} {
        line-height: unset;
        align-self: flex-end;
        height: 18px;
    }
    float: right;
    align-content: end;
    margin-left: 8px;
    font-size: 12px;
    color: ${(props) => props.theme.root.colors.basicColors['50%']};
`;

export const SenderName = styled(Typography)<{ sid: string }>`
    word-wrap: break-word;
    display: inline-block;
    max-width: 225px;
    color: ${(props) => props.theme.getAvatarColorsById(stringToNumber(props.sid)).color};
`;
export const MessageContentWrapper = styled.div`
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    max-width: 100%;
`;

const AvatarBase = styled.div`
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    margin-right: 4px;
    border-radius: 50%;
    user-select: none;
    -webkit-user-drag: none;
`;

export const Avatar = styled(AvatarBase)<{ sid: string; withName: boolean }>`
    color: ${(props) => props.theme.root.colors.basicColors.white['100%']};
    background: ${(props) => props.theme.getAvatarColorsById(stringToNumber(props.sid)).background};
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
`;

export const AvatarImage = styled(AvatarBase).attrs({ as: 'img' })`
    object-fit: contain;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
`;
